import { render } from "./auth.vue?vue&type=template&id=97c01f52"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/layouts/auth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97c01f52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97c01f52', __exports__)) {
    console.log('reload')
    api.reload('97c01f52', __exports__)
  }
  
  module.hot.accept("./auth.vue?vue&type=template&id=97c01f52", () => {
    console.log('re-render')
    api.rerender('97c01f52', render)
  })

}


export default __exports__